var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAidietician(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94238 3.89941C5.41442 3.92914 5.87863 4.09126 6.27441 4.26465C6.66747 4.43685 7.05902 4.65165 7.3418 4.79492C7.49183 4.87093 7.6111 4.92699 7.70605 4.96387C7.77194 4.98945 7.80547 4.99685 7.81445 4.99902C8.21843 4.99829 8.6209 4.95098 9.01367 4.85645L9.96191 4.62891L10.0156 4.61816L10.4961 4.54883C11.2825 4.43524 12.0824 4.63153 12.7266 5.09668C13.4328 5.60672 13.9259 6.4178 13.9336 7.34277C13.9365 7.69536 13.9237 8.09672 13.8711 8.44336C13.6269 10.0511 13.0095 10.9188 12.2266 12.1963C12.0798 12.4357 11.901 12.6954 11.7207 12.9463C10.93 14.0464 9.38701 14.1189 8.42773 13.2529C8.04405 12.9065 7.46765 12.878 7.05566 13.1826C6.29262 13.7467 5.21824 13.8007 4.42969 13.1777C4.09676 12.9146 3.72056 12.5927 3.44434 12.2783C2.83083 11.58 2.50066 10.6556 2.31641 9.82617C2.11795 8.93266 2.03777 7.92495 2.1875 6.96973C2.33749 6.01329 2.72451 5.07191 3.49316 4.37793C3.93253 3.98128 4.4523 3.86861 4.94238 3.89941Z",
    stroke: "#466D91",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAidietician);
export default __webpack_public_path__ + "static/media/aidietician.913617bce4de720e4dcf683c265d24f0.svg";
export { ForwardRef as ReactComponent };